import { Stack } from '@ltvco/refresh-lib/theme';
import {
  LegalFooterStyled,
  LegalFooterContent,
  LegalFooterLinks,
} from './components';
import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { useContext } from 'react';

interface LegalFooterProps {
  handleSkipSubscription: () => Promise<void>;
}

export const LegalFooter = ({ handleSkipSubscription }: LegalFooterProps) => {
  const {
    data: { supportEmail },
  } = useContext(AppConstants);

  return (
    <LegalFooterStyled>
      <Stack spacing={2} alignItems="center">
        <LegalFooterContent variant="h4" textAlign="center">
          Don't want a membership?{' '}
          <LegalFooterLinks
            onClick={handleSkipSubscription}
            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
          >
            Continue using the free Bumper Garage account.
          </LegalFooterLinks>
        </LegalFooterContent>
        <LegalFooterContent variant="body1" textAlign="center">
          Live Customer Support Hours: Mon - Fri, 9am - 5pm EST
        </LegalFooterContent>
      </Stack>

      <LegalFooterContent>
        Bumper, LLC - 48 West 38th Street, 8th Floor, New York, NY 10018. You
        can access our refund policy{' '}
        <LegalFooterLinks
          href="https://www.bumper.com/terms/#17-refund-policy"
          target="_blank"
          rel="noopener noreferrer"
          variant="h5"
        >
          here
        </LegalFooterLinks>
        . You can request a copy of our name, address and refund policy from{' '}
        <LegalFooterLinks
          href={`mailto:${supportEmail}`}
          target="_blank"
          rel="noopener noreferrer"
          variant="h5"
        >
          {supportEmail}
        </LegalFooterLinks>
        .
      </LegalFooterContent>

      <LegalFooterContent>
        **Bumper reports are based upon data available and may include
        historical accident records from 37 state-level agencies, including
        Alaska, Arizona, California, Connecticut, Florida, Georgia, Hawaii,
        Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maryland,
        Massachusetts, Minnesota, Missouri, Montana, Nebraska, Nevada, New
        Mexico, New York, North Carolina, North Dakota, Ohio, Oregon, Rhode
        Island, South Carolina, South Dakota, Tennessee, Texas, Utah, Vermont,
        Washington, Wisconsin, and Wyoming, to the extent such specific data has
        been compiled, digitized locally, and is available. We strongly
        recommend your own due diligence and checking additional sources for
        states not listed above. As a reminder, even for states where we may
        have data, we cannot guarantee the comprehensiveness/accuracy of the
        information provided and you should not rely solely on our data in order
        to determine whether or not a vehicle was ever involved in an accident.
      </LegalFooterContent>

      <LegalFooterContent>
        Bumper Vehicle History products and services are based only on
        information supplied to Bumper, and the information contained in any
        report and on our website is not necessarily 100% accurate, complete or
        up to date, nor a substitute for your own due diligence. Bumper does not
        have the complete history of every vehicle.
      </LegalFooterContent>

      <LegalFooterContent>
        *You can find information about sales tax{' '}
        <LegalFooterLinks
          href="https://www.bumper.com/taxes/"
          target="_blank"
          rel="noopener noreferrer"
          variant="h5"
        >
          here
        </LegalFooterLinks>
        .
      </LegalFooterContent>
    </LegalFooterStyled>
  );
};
